import { createApiThunk } from 'utils/thunkWrapper'
import { sendSuccessNotification } from 'utils/notifications'
import { getChallengeLeaderboard } from 'store/leaderboard/thunks'
import {
  getChallenge as getChallengeApi,
  transitionParticipant,
  addParticipants,
  removeParticipant,
  getChallengeImage,
} from 'api/challenges-v2'
import type {
  AddParticipantsResponse,
  GetChallengeResponse,
  GetImageResponse,
  RemoveParticipantResponse,
  TransitionParticipantStateResponse,
} from 'api/types'

export const getUserChallenge = createApiThunk<GetChallengeResponse, string>({
  action: 'userChallenge',
  request: (id) => getChallengeApi(id),
})

// This will be used to add the user to the challenge, since the addUserToChallenge has only the support
// to invite users to the challenge
export const addUserToChallengeAction = createApiThunk<
  TransitionParticipantStateResponse,
  AddUserToChallengeActionPayload
>({
  action: 'userChallenge/addUserAction',
  request: (payload) =>
    transitionParticipant(payload.challengeId, payload.participantId, 'PARTICIPANT_ACTION_FORCE_ACCEPT'),
  onSuccess: (payload, response, thunkApi) => {
    thunkApi.dispatch(getChallengeLeaderboard({ challengeId: payload.challengeId, params: { limit: 10 } }))
    const participant = response?.data
    const userName =
      participant?.user?.firstName && participant?.user?.lastName
        ? `${participant.user.firstName} ${participant.user.lastName}`
        : 'Player'
    sendSuccessNotification(`${userName} added to the challenge`)
  },
})

export const addUserToChallenge = createApiThunk<AddParticipantsResponse, AddUserToChallengePayload>({
  action: 'userChallenge/addUser',
  request: (payload) => addParticipants(payload.challengeId, { userIds: payload.userIds }),
  onSuccess: (payload, response, thunkApi) => {
    const first = response.data?.[0]
    if (first?.participantId && first?.challengeId) {
      thunkApi.dispatch(
        addUserToChallengeAction({ participantId: first.participantId, challengeId: first.challengeId }),
      )
    }
  },
})

export const removeUserFromChallenge = createApiThunk<
  RemoveParticipantResponse,
  { challengeId: string; participantId: string }
>({
  action: 'userChallenge/removeUser',
  request: ({ challengeId, participantId }) => removeParticipant(challengeId, participantId),
})

export const getChallengeImageV2 = createApiThunk<
  GetImageResponse,
  { challengeId: string; challengeImageType: string }
>({
  action: 'userChallenge/image',
  request: (payload) => getChallengeImage(payload.challengeId, payload.challengeImageType),
})
